import React, { useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Box, Divider, Grid } from '@material-ui/core'
import { useStyles } from './styles'
import { VisibilityOutlined, VisibilityOffOutlined, FlashOn } from '@material-ui/icons'
import eventBattery from '../../Assets/Images/eventBattery.svg'
import electricity from '../../Assets/Images/electricity.svg'

function EnergyPowerInfo(props) {
  const classes = useStyles()
  const [showInfo, setShowInfo] = useState(true)

  const type = _.get(props, 'data.type', '')

  return (
    <Box className={classes.contentWrapper} mt={3.75}>
      <Box display="flex" justifyContent="space-between" className={classes.contentTitle} p={1}>
        <Box>Energy and Power Information</Box>
        {showInfo ? <VisibilityOffOutlined className={classes.eyeIcon} onClick={() => setShowInfo(showInfo => !showInfo)} /> : <VisibilityOutlined className={classes.eyeIcon} onClick={() => setShowInfo(showInfo => !showInfo)} />}
      </Box>
      {showInfo && <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box className={classes.infoBox} display="flex" justifyContent="space-between" >
            <Box display="flex" justifyContent="center" alignItems="center">
              <img src={eventBattery} alt="" />
            </Box>
            <Box display="flex" justifyContent="space-around" flexWrap="wrap" flexGrow="1">
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.energyInfoHeading}>{!_.isNil(props.data.total_battery_charge) ? `${props.data.total_battery_charge.toFixed(2)} kWh` : '0 kWh'}</Box>
                <Box className={classes.infoSubheading}>Total Event Energy</Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.energyInfoHeading}>{!_.isNil(props.data.scheduled_energy_kwh) ? `${props.data.scheduled_energy_kwh.toFixed(2)} kWh` : '0 kWh'}</Box>
                <Box className={classes.infoSubheading}>{`Scheduled Energy`}</Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.energyInfoHeading}>{type === 'BATTERY_DISCHARGE' ? !_.isNil(props.data.Kwh_energy_dispatched) ? `${props.data.Kwh_energy_dispatched.toFixed(2)} kWh` : '0 kWh' : !_.isNil(props.data.Kwh_energy_charged) ? `${props.data.Kwh_energy_charged.toFixed(2)} kWh` : '0 kWh'}</Box>
                <Box className={classes.infoSubheading}>{`Actual Energy`}</Box>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box className={classes.infoBox} display="flex" justifyContent="space-between">
            <Box display="flex" justifyContent="center" alignItems="center">
              <img src={electricity} alt="" />
            </Box>
            <Box display="flex" justifyContent="space-around" flexWrap="wrap" flexGrow="1">
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.powerInfoHeading}>{!_.isNil(props.data.total_battery_power) ? `${props.data.total_battery_power.toFixed(2)} kW` : '0 kW'}</Box>
                <Box className={classes.infoSubheading}>Total Event Power</Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.powerInfoHeading}>{!_.isNil(props.data.scheduled_power_kw) ? `${props.data.scheduled_power_kw.toFixed(2)} kW` : '0 kW'}</Box>
                <Box className={classes.infoSubheading}>{`Scheduled Power`}</Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mx={2}>
                <Box className={classes.powerInfoHeading}>{type === 'BATTERY_DISCHARGE' ? !_.isNil(props.data.Avg_kw_executed) ? `${props.data.Avg_kw_executed.toFixed(2)} kW` : '0 kW' : !_.isNil(props.data.Avg_kw_charged) ? `${props.data.Avg_kw_charged.toFixed(2)} kW` : '0 kW'}</Box>
                <Box className={classes.infoSubheading}>{`Actual Power`}</Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      }
    </Box>
  )
}

const mapStateToProps = ({ auth, programs }) => {
  const { accountId } = auth
  return { accountId }
}

export default connect(mapStateToProps, {})(EnergyPowerInfo)